var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-layout',[_c('section',{staticClass:"page-section"},[_c('div',{attrs:{"id":"editorjs"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }